import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=09b63649&scoped=true"
import script from "./baseDialog.vue?vue&type=script&lang=jsx"
export * from "./baseDialog.vue?vue&type=script&lang=jsx"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=09b63649&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b63649",
  null
  
)

export default component.exports